import { useMutation } from 'react-query';
import { deletePlan } from '../../../../../api/services/mediaPlanning/deletePlan';
import queryClient from '../../../../../config/queryClient';
import { useError } from '../../common/Errors/ErrorContext/ErrorContext';

const useDeletePlan = () => {
  const { showError } = useError();

  const {
    mutate: deletePlanTrigger,
    data: response,
    isLoading,
    isError,
  } = useMutation(
    async (deletedPlanId: string) => {
      return deletePlan(deletedPlanId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['get-media-plans'],
        });
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
    }
  );

  return {
    deletePlan: deletePlanTrigger,
    data: response?.data,
    isLoading,
    isError,
  };
};

export default useDeletePlan;
